/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tags_Searchplaceholder1Inputs */

const id_tags_searchplaceholder1 = /** @type {(inputs: Tags_Searchplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cari...`)
};

const ms_tags_searchplaceholder1 = /** @type {(inputs: Tags_Searchplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cari...`)
};

const da_tags_searchplaceholder1 = /** @type {(inputs: Tags_Searchplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Søg...`)
};

const de_tags_searchplaceholder1 = /** @type {(inputs: Tags_Searchplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suchen...`)
};

const en_us2_tags_searchplaceholder1 = /** @type {(inputs: Tags_Searchplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search...`)
};

const es_es2_tags_searchplaceholder1 = /** @type {(inputs: Tags_Searchplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buscar...`)
};

const es_mx2_tags_searchplaceholder1 = /** @type {(inputs: Tags_Searchplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buscar...`)
};

const fil_tags_searchplaceholder1 = /** @type {(inputs: Tags_Searchplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maghanap...`)
};

const fr_tags_searchplaceholder1 = /** @type {(inputs: Tags_Searchplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rechercher…`)
};

const it_tags_searchplaceholder1 = /** @type {(inputs: Tags_Searchplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cerca...`)
};

const hu_tags_searchplaceholder1 = /** @type {(inputs: Tags_Searchplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keresés...`)
};

const nl_tags_searchplaceholder1 = /** @type {(inputs: Tags_Searchplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zoeken...`)
};

const no_tags_searchplaceholder1 = /** @type {(inputs: Tags_Searchplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Søk...`)
};

const pl_tags_searchplaceholder1 = /** @type {(inputs: Tags_Searchplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Szukaj...`)
};

const pt_br2_tags_searchplaceholder1 = /** @type {(inputs: Tags_Searchplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Procurar...`)
};

const pt_tags_searchplaceholder1 = /** @type {(inputs: Tags_Searchplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pesquisar...`)
};

const ro_tags_searchplaceholder1 = /** @type {(inputs: Tags_Searchplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Căutare...`)
};

const fi_tags_searchplaceholder1 = /** @type {(inputs: Tags_Searchplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hae...`)
};

const sv_tags_searchplaceholder1 = /** @type {(inputs: Tags_Searchplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sök...`)
};

const vi_tags_searchplaceholder1 = /** @type {(inputs: Tags_Searchplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tìm kiếm...`)
};

const tr_tags_searchplaceholder1 = /** @type {(inputs: Tags_Searchplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ara...`)
};

const cs_tags_searchplaceholder1 = /** @type {(inputs: Tags_Searchplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hledat...`)
};

const bg_tags_searchplaceholder1 = /** @type {(inputs: Tags_Searchplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Търсене...`)
};

const ru_tags_searchplaceholder1 = /** @type {(inputs: Tags_Searchplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Поиск...`)
};

const uk_tags_searchplaceholder1 = /** @type {(inputs: Tags_Searchplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пошук...`)
};

const ar_tags_searchplaceholder1 = /** @type {(inputs: Tags_Searchplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`بحث...`)
};

const hi_tags_searchplaceholder1 = /** @type {(inputs: Tags_Searchplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`खोज...`)
};

const th_tags_searchplaceholder1 = /** @type {(inputs: Tags_Searchplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ค้นหา...`)
};

const ja_tags_searchplaceholder1 = /** @type {(inputs: Tags_Searchplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`検索...`)
};

const zh_cn2_tags_searchplaceholder1 = /** @type {(inputs: Tags_Searchplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`搜索...`)
};

const zh_hant1_tags_searchplaceholder1 = /** @type {(inputs: Tags_Searchplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`搜尋...`)
};

const ko_tags_searchplaceholder1 = /** @type {(inputs: Tags_Searchplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`검색...`)
};

/**
* | output |
* | --- |
* | "Search..." |
*
* @param {Tags_Searchplaceholder1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const tags_searchplaceholder1 = /** @type {((inputs?: Tags_Searchplaceholder1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tags_Searchplaceholder1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tags_searchplaceholder1(inputs)
	if (locale === "ms") return ms_tags_searchplaceholder1(inputs)
	if (locale === "da") return da_tags_searchplaceholder1(inputs)
	if (locale === "de") return de_tags_searchplaceholder1(inputs)
	if (locale === "en-US") return en_us2_tags_searchplaceholder1(inputs)
	if (locale === "es-ES") return es_es2_tags_searchplaceholder1(inputs)
	if (locale === "es-MX") return es_mx2_tags_searchplaceholder1(inputs)
	if (locale === "fil") return fil_tags_searchplaceholder1(inputs)
	if (locale === "fr") return fr_tags_searchplaceholder1(inputs)
	if (locale === "it") return it_tags_searchplaceholder1(inputs)
	if (locale === "hu") return hu_tags_searchplaceholder1(inputs)
	if (locale === "nl") return nl_tags_searchplaceholder1(inputs)
	if (locale === "no") return no_tags_searchplaceholder1(inputs)
	if (locale === "pl") return pl_tags_searchplaceholder1(inputs)
	if (locale === "pt-BR") return pt_br2_tags_searchplaceholder1(inputs)
	if (locale === "pt") return pt_tags_searchplaceholder1(inputs)
	if (locale === "ro") return ro_tags_searchplaceholder1(inputs)
	if (locale === "fi") return fi_tags_searchplaceholder1(inputs)
	if (locale === "sv") return sv_tags_searchplaceholder1(inputs)
	if (locale === "vi") return vi_tags_searchplaceholder1(inputs)
	if (locale === "tr") return tr_tags_searchplaceholder1(inputs)
	if (locale === "cs") return cs_tags_searchplaceholder1(inputs)
	if (locale === "bg") return bg_tags_searchplaceholder1(inputs)
	if (locale === "ru") return ru_tags_searchplaceholder1(inputs)
	if (locale === "uk") return uk_tags_searchplaceholder1(inputs)
	if (locale === "ar") return ar_tags_searchplaceholder1(inputs)
	if (locale === "hi") return hi_tags_searchplaceholder1(inputs)
	if (locale === "th") return th_tags_searchplaceholder1(inputs)
	if (locale === "ja") return ja_tags_searchplaceholder1(inputs)
	if (locale === "zh-CN") return zh_cn2_tags_searchplaceholder1(inputs)
	if (locale === "zh-Hant") return zh_hant1_tags_searchplaceholder1(inputs)
	return ko_tags_searchplaceholder1(inputs)
});
export { tags_searchplaceholder1 as "tags.searchPlaceholder" }